import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, DollarSign } from 'lucide-react';

function Donations() {
  const [amount, setAmount] = useState('');
  const navigate = useNavigate();

  const handleDonate = () => {
  const numAmount = parseFloat(amount);
  if (!numAmount || numAmount < 1) {
    alert('El monto mínimo es $1');
    return;
  }
  if (numAmount > 10000) {
    alert('El monto máximo es $10,000');
    return;
  }
  // Guardar monto en localStorage y redirigir
  localStorage.setItem('donationAmount', numAmount.toString());
  navigate('/pago-donacion');
};

  const presetAmounts = [5, 10, 25, 50, 100];

  return (
    <div className="app-container">
      <div className="payment-card">
        <div className="card-header">
          <div className="icon-shield" style={{ background: 'linear-gradient(135deg, #ec4899, #f43f5e)' }}>
            <Heart className="icon-large" />
          </div>
          <h1 className="title">Donaciones</h1>
          <p className="subtitle">Apoya con el monto que desees</p>
        </div>

        {/* Montos predefinidos */}
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center', margin: '20px 0' }}>
          {presetAmounts.map(preset => (
            <button
              key={preset}
              onClick={() => setAmount(preset.toString())}
              style={{
                padding: '10px 20px',
                borderRadius: '8px',
                border: amount === preset.toString() ? '2px solid #a855f7' : '2px solid rgba(255,255,255,0.2)',
                background: amount === preset.toString() ? 'rgba(168, 85, 247, 0.2)' : 'rgba(255,255,255,0.05)',
                color: '#fff',
                cursor: 'pointer',
                fontSize: '16px',
                fontWeight: '600'
              }}
            >
              ${preset}
            </button>
          ))}
        </div>

        {/* Input personalizado */}
        <div style={{ margin: '20px 0' }}>
          <label style={{ color: '#94a3b8', fontSize: '14px', marginBottom: '8px', display: 'block' }}>
            O introduce un monto personalizado:
          </label>
          <div style={{ position: 'relative' }}>
            <DollarSign 
              size={20} 
              style={{ 
                position: 'absolute', 
                left: '12px', 
                top: '50%', 
                transform: 'translateY(-50%)', 
                color: '#94a3b8' 
              }} 
            />
            <input
              type="number"
              min="1"
              max="10000"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0.00"
              style={{
                width: '100%',
                padding: '14px 14px 14px 40px',
                borderRadius: '12px',
                border: '1px solid rgba(255,255,255,0.2)',
                background: 'rgba(255,255,255,0.05)',
                color: '#fff',
                fontSize: '18px',
                outline: 'none'
              }}
            />
          </div>
        </div>

        {/* Botón donar */}
        <button
          onClick={handleDonate}
          disabled={!amount || parseFloat(amount) < 1}
          className="payment-button"
          style={{
            width: '100%',
            opacity: (!amount || parseFloat(amount) < 1) ? 0.6 : 1
          }}
        >
          {amount && parseFloat(amount) >= 1 
            ? `Donar $${parseFloat(amount).toFixed(2)} USD` 
            : 'Introduce un monto'}
        </button>

        <p className="footer-text" style={{ marginTop: '20px' }}>
          100% seguro · Sin comisiones
        </p>
      </div>
    </div>
  );
}

export default Donations;